import PP46 from './PP46'

export default PP46